const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/the_marathi_photographer/" },
  { name: "LinkedIn", href: "https://in.linkedin.com/in/swaraj-sawant-svo" },
  { name: "Behance", href: "https://www.behance.net/swarajsawant" },
];

export const Footer = () => (
  <footer
    className="relative border-t border-white/10 bg-[#0a0a0a]"
    data-testid="site-footer"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-16 lg:px-10">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
        <div>
          <h3 className="font-serif text-5xl tracking-tight text-white sm:text-6xl">
            Let's make
            <br />
            <span className="italic text-gold">something great.</span>
          </h3>
        </div>
        <div className="flex flex-col gap-2 text-sm text-zinc-500">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${s.name.toLowerCase()}`}
              className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-white"
            >
              {s.name}
              <span aria-hidden="true" className="text-zinc-700">↗</span>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-zinc-600 sm:flex-row sm:items-center">
        <p>© {new Date().getFullYear()} Swaraj Sawant — Creative Producer.</p>
        <p className="text-zinc-700">Crafted frame by frame.</p>
      </div>
    </div>
  </footer>
);
